import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./action";
import getters from "./getters";

Vue.use(Vuex);
const globalBG = "#FE4D45";
const globalBG1="#364ECF";

const powerScoreList = [
  // 会员权益 根据索引 0 潜在 1 一星 2 二星。。。
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
  [
    {
      name: "购物送积分",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
      link: "",
      id: 1,
    },
    {
      name: "新人优惠券",
      imageUrl: require("@/assets/images/btn_power2_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=1",
      id: 2,
    },
    {
      name: "会员券",
      imageUrl: require("@/assets/images/btn_power3_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/discount_coupon?index=2",
      id: 3,
    },
    {
      name: "积分兑换",
      imageUrl: require("@/assets/images/btn_power4_n.png"),
      link: "https://yphy-isv.isvjcloud.com/point-h5/IntegralStore?index=3",
      id: 4,
    },
  ],
];

const globalLableList = [
  {
    key: '#CustomerName#',
    value: '消费者昵称'
  },
  {
    key: '#CommentLink#',
    value: '评价链接'
  },
  {
    key: '#CSContact#',
    value: '客服昵称'
  },
  {
    key: '#ActivityName#',
    value: '活动名称'
  },
  {
    key: '#WareTitle#',
    value: '商品名称'
  },
  {
    key: '#PayLink#',
    value: '付款链接'
  },
  {
    key: '#OrderId#',
    value: '订单编号'
  },
  {
    key: '#Logistics#',
    value: '物流'
  },
  {
    key: '#LogisticsNumber#',
    value: '物流单号'
  },
  {
    key: '#ShopName#',
    value: '店铺名称'
  },
  {
    key: '#OrderContent#',
    value: '订单内容'
  },
  {
    key: '#ShopLink#',
    value: '店铺连接'
  },
  {
    key: '#CouponLink#',
    value: '领券链接'
  },
  {
    key: '#OrderTime#',
    value: '下单时间'
  },
  {
    key: '#OrderAmount#',
    value: '订单金额'
  },
  {
    key: '#Freight Cost#',
    value: '邮费'
  },
  {
    key: '#itemlink#',
    value: '商品链接'
  },
  {
    key: '#LandingPage#',
    value: '自定义链接'
  }
];

const roiTip = '投入：产出=短信成功扣费条数×短信单价（普通短信按0.05元算，富信按0.42元算，卡片短信按0.38元算）：挽回金额（例如ROI=1:20 相当于花1元带来20元的收益）';

const globalVersion = '2021.02.25.intell-1';

const globalActivityTip =
  "";

const pageArr = [
  ,
  "menberPage",
  "integralTask",
  "integralPlay",
  "integralShop",
  "personalCenter",
]; // 页面
const configArr = [
  ,
  "powerList",
  "hotList",
  "exchangeList",
  "activityList",
  "playList",
  ,
  ,
  "actualList",
  "couponList",
  "detailedList",
]; // 每个页面的组件列表
const pageLink = [
  ,
  // 存储H5里边玩法页面的路径
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/sign_polite", //每日签到
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/rob_goodPresent", //每日抢好礼
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/attention_shop", //关注店铺有礼
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/invitation_openCard", //邀请开卡
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/invitation_attention", //邀请关注店铺
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/perfect_information", //完善信息有礼
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/lottery_turntable", //大转盘抽奖
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/IntegralStore", //积分兑换实物
  // "https://ypsj-isv.isvjcloud.com/point-h5/#/IntegralStore", //积分兑换优惠券
  "www.每日签到.com",
  "www.每日抢好礼.com",
  "www.关注店铺有礼.com",
  "www.邀请开卡.com",
  "www.邀请关注店铺.com",
  "www.完善信息有礼.com",
  "www.大转盘抽奖.com",
  "www.积分兑换实物.com",
  "www.积分兑换优惠券.com",
  ,
];
// 会员权益的tab栏选中
let selectPowerItem = 0;

// 设置全局变量
const state = {
  yearReportStatus: "",
  survey: false,
  venderId: "",
  globalBG: globalBG,
  globalBG1:globalBG1,
  roiTip: roiTip,
  globalVersion: globalVersion,
  globalActivityTip: globalActivityTip,
  globalLableList: globalLableList,
  pathNow: [],
  route: [],
  topPx: 0,
  loginUserInfo: {},
  cityProvinceData: [],
  pointUserInfo:'',
  shopInfo: {},
  isRefresh:false,
  otherRight: [], //其它权限
  modelName: {
    flag: false,
    type: "",
    name: "",
    chirdrenName: "",
  },
  switchList: [],
  //要设置的全局访问的state对象
  // 当前选中的页面 1 会员首页 2 积分任务 3 积分乐园 4 积分商城 5 个人中心
  selectPage: 1,
  // 全部页面的组件列表  id属性必须唯一，不然在sortablejs中渲染dom的时候总是出现莫名其妙的问题
  componentList: [
    [
      {
        name: "我的权益",
        id: 1,
        icon: require("@/assets/images/icon_1.png"),
        disabled: false,
        bgImage: require("@/assets/images/bg1.png"),
      },
      {
        name: "热门互动",
        id: 2,
        icon: require("@/assets/images/icon_2.png"),
        disabled: false,
        bgImage: require("@/assets/images/bg2.png"),
      },
      {
        name: "兑换精选",
        id: 3,
        icon: require("@/assets/images/icon_3.png"),
        disabled: false,
        bgImage: require("@/assets/images/bg3.png"),
      },
    ],
    [
      // {name: '任务主题', id: 1, icon: require('@/assets/images/icon_4.png')},
      // {name: '等级积分', id: 2, icon: require('@/assets/images/icon_5.png')},
      {
        name: "活动列表",
        id: 4,
        icon: require("@/assets/images/icon_6.png"),
        disabled: false,
        bgImage: require("@/assets/images/integralTask_draw_bg.png"),
      },
    ],
    [
      // {name: '乐园主题', id: 1, icon: require('@/assets/images/icon_4.png'), disabled: false},
      // {name: '等级积分', id: 2, icon: require('@/assets/images/icon_5.png'), disabled: false},
      {
        name: "活动列表",
        id: 5,
        icon: require("@/assets/images/icon_6.png"),
        disabled: false,
        bgImage: require("@/assets/images/integralPlay_draw_bg.png"),
      },
    ],
    [
      // {name: '商城主题', id: 6, icon: require('@/assets/images/icon_4.png'), disabled: false},
      // {name: '积分记录', id: 7, icon: require('@/assets/images/icon_7.png'), disabled: false},
      {
        name: "兑换实物",
        id: 8,
        icon: require("@/assets/images/icon_3.png"),
        disabled: false,
        bgImage: require("@/assets/images/integralShop_actual_bg.png"),
      },
      {
        name: "兑换优惠券",
        id: 9,
        icon: require("@/assets/images/icon_8.png"),
        disabled: false,
        bgImage: require("@/assets/images/integralShop_coupon_bg.png"),
      },
    ],
    [
      // {name: '个人主题', id: 10, icon: require('@/assets/images/icon_4.png'), disabled: false},
      {
        name: "列表模块",
        id: 10,
        icon: require("@/assets/images/icon_6.png"),
        disabled: false,
        bgImage: require("@/assets/images/personalCenter_bg.png"),
      },
    ],
  ],
  // 每个页面对应的配置项数据
  pageConfig: {
    // 会员首页
    menberPage: {
      currentCrad: {
        card: require("@/assets/images/card_bg1.png"),
        id: 1,
      },
      color: "#4F3407", //文字颜色
      bgColor: "#ffffff", //文字背景颜色
      // 添加到页面中的组件列表
      pageComponents: [],
      // 会员权益的tab栏选中
      selectPowerItem: 0,
      powerScoreList: powerScoreList,
      // 存储会员权益列表
      powerList: powerScoreList[selectPowerItem],
      // 存储热门互动列表
      hotList: [
        // {
        //   name: "日历签到",
        //   id: 1,
        //   desc: "天天爱签到",
        //   imageUrl: require("@/assets/images/hot_rlqd.png"),
        //   color: "#77C8FE",
        //   visibility: true,
        // },
        // {
        //   name: "完善信息",
        //   id: 2,
        //   desc: "浏览商品享好礼",
        //   imageUrl: require("@/assets/images/hot_wsxx.png"),
        //   color: "#46BFBB",
        //   visibility: true,
        // },
        // {
        //   name: "每日抢好礼",
        //   id: 3,
        //   desc: "蹲点抢大礼包",
        //   imageUrl: require("@/assets/images/hot_mrq.png"),
        //   color: "#FE8577",
        //   visibility: true,
        // },
        // {
        //   name: "关注店铺有礼",
        //   id: 4,
        //   desc: "关注店铺享好礼",
        //   imageUrl: require("@/assets/images/hot_gzdp.png"),
        //   color: "#FFA447",
        //   visibility: true,
        // },
      ],
      // 存储兑换精选列表
      exchangeList: [
        {
          name: "小米小爱音箱Pro1",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 1,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro2",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 2,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro3",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 3,
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部 1 权益配置 2 热门互动 3 兑换精选
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
      // 卡面列表
      cradList: [
        {
          name: "尊贵黄金",
          imageUrl: require("@/assets/images/card_bg1.png"),
          id: 1,
        },
        {
          name: "永恒黑暗",
          imageUrl: require("@/assets/images/card_bg2.png"),
          id: 2,
        },
        {
          name: "什么白银",
          imageUrl: require("@/assets/images/card_bg3.png"),
          id: 3,
        },
      ],
      // 背景图列表
      bgImageList: [
        {
          name: "暗黑",
          imageUrl: require("@/assets/images/head_bg1.png"),
          id: 1,
        },
        {
          name: "白银",
          imageUrl: require("@/assets/images/head_bg2.png"),
          id: 2,
        },
        {
          name: "黄金",
          imageUrl: require("@/assets/images/head_bg3.png"),
          id: 3,
        },
      ],
      // 当前背景图
      currentImage: {
        src: require("@/assets/images/head_bg1.png"),
        id: 1,
      },
    },
    // 积分任务
    integralTask: {
      backgroundSrc: require("@/assets/images/integralTask_bg1.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      activityList: [
        {
          id: 11,
          imageUrl: require("@/assets/images/icon_lxqd.png"),
          activityName: "连续签到",
          desc: "天天爱签到",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 12,
          imageUrl: require("@/assets/images/icon_mrqhl.png"),
          activityName: "每日抢好礼",
          desc: "每日抢好礼",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 13,
          imageUrl: require("@/assets/images/icon_gzdp.png"),
          activityName: "关注店铺",
          desc: "天天关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 14,
          imageUrl: require("@/assets/images/icon_yqkk.png"),
          activityName: "邀请开卡",
          desc: "邀请开卡",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 15,
          imageUrl: require("@/assets/images/icon_yqgzdp.png"),
          activityName: "邀请关注店铺",
          desc: "天天邀请关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部背景 1等级积分  3 活动列表
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
    },
    // 积分乐园

    integralPlay: {
      backgroundSrc: require("@/assets/images/integralPlay_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      playList: [
        {
          id: 22,
          imageUrl: require("@/assets/images/icon_dzpcj.png"),
          name: "大转盘抽奖",
          desc: "转出好运",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 积分商城
    integralShop: {
      backgroundSrc: require("@/assets/images/integralShop_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
      ],
      // 实物列表
      actualList: [
        {
          id: 33,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 34,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 35,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 兑换券列表
      couponList: [
        {
          id: 36,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 37,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 38,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 个人中心
    personalCenter: {
      backgroundSrc: require("@/assets/images/personalCenter_bg.jpg"),
      pageComponents: [],
      // 明细列表
      detailedList: [
        {
          id: 55,
          imageUrl: require("@/assets/images/icon_personalCenter1.png"),
          name: "积分明细",
        },
        {
          id: 56,
          imageUrl: require("@/assets/images/icon_personalCenter2.png"),
          name: "活动记录",
        },
        {
          id: 57,
          imageUrl: require("@/assets/images/icon_personalCenter3.png"),
          name: "兑换记录",
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
  },
  pageConfigtwo: {
    // 会员首页
    menberPage: {
      currentCrad: {
        card: require("@/assets/images/card_bg1.png"),
        id: 1,
      },
      color: "#4F3407", //文字颜色
      bgColor: "#ffffff", //文字背景颜色
      // 添加到页面中的组件列表
      pageComponents: [
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 1, hideGaps: false, select: false, intRecord: true },
        { id: 2, hideGaps: false, select: false, intRecord: true },
        { id: 3, hideGaps: false, select: false, intRecord: true },
      ],
      // 会员权益的tab栏选中
      selectPowerItem: 0,
      powerScoreList: [...powerScoreList],
      // 存储会员权益列表
      powerList: powerScoreList[selectPowerItem],
      // 存储热门互动列表
      hotList: [
        {
          name: "日历签到",
          id: 1,
          desc: "天天爱签到",
          imageUrl: require("@/assets/images/hot_rlqd.png"),
          color: "#77C8FE",
          visibility: true,
        },
        {
          name: "完善信息",
          id: 2,
          desc: "浏览商品享好礼",
          imageUrl: require("@/assets/images/hot_wsxx.png"),
          color: "#46BFBB",
          visibility: true,
        },
        {
          name: "每日抢好礼",
          id: 3,
          desc: "蹲点抢大礼包",
          imageUrl: require("@/assets/images/hot_mrq.png"),
          color: "#FE8577",
          visibility: true,
        },
        {
          name: "关注店铺有礼",
          id: 4,
          desc: "关注店铺享好礼",
          imageUrl: require("@/assets/images/hot_gzdp.png"),
          color: "#FFA447",
          visibility: true,
        },
      ],
      // 存储兑换精选列表
      exchangeList: [
        {
          name: "小米小爱音箱Pro1",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 1,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro2",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 2,
          visibility: true,
        },
        {
          name: "小米小爱音箱Pro3",
          int: "12000",
          imageUrl: require("@/assets/images/dh_goods.png"),
          id: 3,
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部 1 权益配置 2 热门互动 3 兑换精选
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
      // 卡面列表
      cradList: [
        {
          name: "尊贵黄金",
          imageUrl: require("@/assets/images/card_bg1.png"),
          id: 1,
        },
        {
          name: "永恒黑暗",
          imageUrl: require("@/assets/images/card_bg2.png"),
          id: 2,
        },
        {
          name: "什么白银",
          imageUrl: require("@/assets/images/card_bg3.png"),
          id: 3,
        },
      ],
      // 背景图列表
      bgImageList: [
        {
          name: "暗黑",
          imageUrl: require("@/assets/images/head_bg1.png"),
          id: 1,
        },
        {
          name: "白银",
          imageUrl: require("@/assets/images/head_bg2.png"),
          id: 2,
        },
        {
          name: "黄金",
          imageUrl: require("@/assets/images/head_bg3.png"),
          id: 3,
        },
      ],
      // 当前背景图
      currentImage: {
        src: require("@/assets/images/head_bg1.png"),
        id: 1,
      },
    },
    // 积分任务
    integralTask: {
      backgroundSrc: require("@/assets/images/integralTask_bg1.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 4, hideGaps: false, select: false, intRecord: true },
      ],
      activityList: [
        {
          id: 11,
          imageUrl: require("@/assets/images/icon_lxqd.png"),
          activityName: "连续签到",
          desc: "连续签到",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 12,
          imageUrl: require("@/assets/images/icon_mrqhl.png"),
          activityName: "每日抢好礼",
          desc: "每日抢好礼",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 13,
          imageUrl: require("@/assets/images/icon_gzdp.png"),
          activityName: "关注店铺",
          desc: "关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 14,
          imageUrl: require("@/assets/images/icon_yqkk.png"),
          activityName: "邀请开卡",
          desc: "邀请开卡",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 15,
          imageUrl: require("@/assets/images/icon_yqgzdp.png"),
          activityName: "邀请关注店铺",
          desc: "邀请关注店铺",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 右侧配置显示对应 0 头部背景 1等级积分  3 活动列表
      configState: null,
      // 会员页面模块是否隐藏间隙的显示状态
      pageHideGaps: false,
    },
    // 积分乐园
    integralPlay: {
      backgroundSrc: require("@/assets/images/integralPlay_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 5, hideGaps: false, select: false, intRecord: true },
      ],
      playList: [
        {
          id: 22,
          imageUrl: require("@/assets/images/icon_dzpcj.png"),
          name: "大转盘抽奖",
          desc: "转出好运",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 积分商城
    integralShop: {
      backgroundSrc: require("@/assets/images/integralShop_bg.jpg"),
      uploadIcon: require("@/assets/images/icon_upload.png"),
      pageComponents: [
        // 等级积分设置的组件，不需要拖拽添加直接写死
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 8, hideGaps: false, select: false, intRecord: true },
      ],
      // 实物列表
      actualList: [
        {
          id: 33,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 34,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 35,
          imageUrl: require("@/assets/images/dh_goods.png"),
          goodName: "小米 AloT路由器",
          desc: "天天爱小米 AloT路由器",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      // 兑换券列表
      couponList: [
        {
          id: 36,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 37,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
        {
          id: 38,
          imageUrl: require("@/assets/images/icon_coupon.png"),
          goodName: "积分兑换优惠券",
          desc: "剩余100份",
          startTime: "2019.02.25",
          endTime: "2019.06.30",
          link: "",
          visibility: true,
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
    // 个人中心
    personalCenter: {
      backgroundSrc: require("@/assets/images/personalCenter_bg.jpg"),
      pageComponents: [
        { id: 99, hideGaps: false, select: false, intRecord: true },
        { id: 10, hideGaps: false, select: false, intRecord: true },
      ],
      // 明细列表
      detailedList: [
        {
          id: 55,
          imageUrl: require("@/assets/images/icon_personalCenter1.png"),
          name: "积分明细",
        },
        {
          id: 56,
          imageUrl: require("@/assets/images/icon_personalCenter2.png"),
          name: "活动记录",
        },
        {
          id: 57,
          imageUrl: require("@/assets/images/icon_personalCenter3.png"),
          name: "兑换记录",
        },
      ],
      configState: null,
      pageHideGaps: false,
    },
  },
  // 存储当前选中的链接项
  curLinkItem: "",
  //要设置的初始属性值
  peopleNumState: 300, // 是否为人群策略数量的特定商家
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
